import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-ml30 -mr30" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "-page-tip -mt10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "-title" }, "菜单设置"),
  /*#__PURE__*/_createElementVNode("div", { class: "-content" }, " 根据使用需要，选择菜单后，菜单将会在首页显示，作为菜单入口快速进入相应模块 ")
], -1)
const _hoisted_3 = { class: "-ml100 -mt50 -fl -w500" }
const _hoisted_4 = { class: "-mt30" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存")

import { ref } from 'vue'
	import type { ElTree } from 'element-plus'
	import type Node from 'element-plus/es/components/tree/src/model/node'

	interface Tree {
	  id: number
	  label: string
	  children?: Tree[]
	}

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const treeRef = ref<InstanceType<typeof ElTree>>()

	const getCheckedNodes = () => {
	  console.log(treeRef.value!.getCheckedNodes(false, false))
	}
	const getCheckedKeys = () => {
	  console.log(treeRef.value!.getCheckedKeys(false))
	}
	const setCheckedNodes = () => {
	  treeRef.value!.setCheckedNodes(
		[
		  {
			id: 5,
			label: 'Level two 2-1',
		  },
		  {
			id: 9,
			label: 'Level three 1-1-1',
		  },
		] as Node[],
		false
	  )
	}
	const setCheckedKeys = () => {
	  treeRef.value!.setCheckedKeys([3], false)
	}
	const resetChecked = () => {
	  treeRef.value!.setCheckedKeys([], false)
	}

	const defaultProps = {
	  children: 'children',
	  label: 'label',
	}

	const data: Tree[] = [
	  {
		id: 1,
		label: '商户管理',
		children: [
		  {
			id: 4,
			label: '油站运营',
			children: [
			  {
				id: 9,
				label: '油品设置',
			  },
			  {
				id: 10,
				label: '电子卡记录',
			  },
			  {
			  	id: 11,
			  	label: '加油记录',
			  },
			  {
			  	id: 12,
			  	label: '价格折扣',
			  },
			  {
			  	id: 13,
			  	label: '促销活动',
			  },
			],
		  },
		],
	  },
	  {
		id: 2,
		label: '订单管理',
		children: [
		  {
			id: 5,
			label: '加油订单',
		  },
		  {
			id: 6,
			label: '商城订单',
		  },
		  
		],
	  },
	  {
		id: 3,
		label: '平台服务',
		children: [
		  {
			id: 7,
			label: '商城服务',
		  },
		  {
			id: 8,
			label: '联合油品采购',
		  },
		],
	  },
	]

return (_ctx: any,_cache: any) => {
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_tree, {
        ref: (_value, _refs) => {
          _refs['treeRef'] = _value
          treeRef.value = _value
        },
        data: data,
        "show-checkbox": "",
        "default-expand-all": "",
        "node-key": "id",
        "highlight-current": "",
        props: defaultProps
      }, null, 512),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, { type: "primary" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})